import { createFileRoute } from "@tanstack/react-router";
import { RegistrationPage } from "../../components/participant/registration/registration-page";

/** `/me/registration/:acCardId` — a participant finishes their own registration (DRAFT / RETURN). Under `/me`, so the `_app` guard lets only PARTICIPANT sessions in. */
export const Route = createFileRoute("/_app/me/registration/$acCardId")({
	component: function RegistrationRoute() {
		const { acCardId } = Route.useParams();
		return <RegistrationPage acCardId={acCardId} />;
	},
});
